import { AppRouteConfig, breadcrumbs } from '..';
import { publishedRoutes } from './published';

export enum ProgramsRouteName {
	program = 'Program',
	draftList = 'ProgramDraftList',
	publishedList = 'PublishedList',
	programReportList = 'ProgramReportList',
	programReportFunderReport = 'ProgramReportFunderReport',
	programEventList = 'ProgramEventList',
	ProgramEventJobDetailsList = 'ProgramEventJobDetailsList',
	ProgramEventEventDetailsList = 'ProgramEventEventDetailsList',
	programEventAddJob = 'ProgramEventAddJob',
	programEventAddEvent = 'programEventAddEvent',
	newProgram = 'NewProgram',
	editProgram = 'EditProgram',
	editProgramMain = 'EditProgramMain',
	proposalAndEvaluationList = 'ProposalAndEvaluationList',
	advancePaymentRequestList = 'AdvancePaymentRequestList',
	editProposalMain = 'editProposalMain',
	newProposal = 'NewProposal',
	editProposal = 'EditProposal',
	newAdvancePaymentRequest = 'NewAdvancePaymentRequest',
	editAdvancePaymentRequest = 'EditAdvancePaymentRequest',
	newEvaluation = 'NewEvaluation',
	editEvaluation = 'EditEvaluation',
	proposalRelatedEventsList = 'ProposalRelatedEventsList',
}

export function programsRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'draft',
			name: ProgramsRouteName.draftList,
			component: () => import('../../views/program/DraftList.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('draftPrograms'),
				],
				caslSubject: 'programs.draft_programs',
				caslAction: 'view',
				maskFeature: ['programs'],
			},
		},
		{
			path: 'published',
			component: { render: c => c('router-view') },
			meta: {
				caslSubject: 'programs.published_programs',
				caslAction: 'view',
			},
			children: publishedRoutes(),
		},
		{
			path: ':programId/proposals/:proposalId/events',
			name: ProgramsRouteName.proposalRelatedEventsList,
			component: () => import('../../views/program/ProposalEventList.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('publishedPrograms'),
					breadcrumbs.get('proposalAndEvaluation'),
					breadcrumbs.get('evaluationDetails'),
					breadcrumbs.get('relatedEvents'),
				],
				caslSubject: 'programs.program_forms',
				caslAction: 'view',
			},
		},
	];
}

export function programsEditRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'new',
			name: ProgramsRouteName.newProgram,
			component: () => import('../../views/program/ProgramEdit.vue'),
			meta: {
				caslSubject: 'programs.draft_programs',
				caslAction: 'edit',
			},
		},
		{
			path: ':id',
			name: ProgramsRouteName.editProgram,
			component: () => import('../../views/program/ProgramEdit.vue'),
			meta: {
				caslSubject: 'programs.published_programs',
				caslAction: 'view',
			},
		},
	];
}

export function programProposalsEditRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'new',
			name: ProgramsRouteName.newProposal,
			component: () => import('../../views/program/proposal/ProposalEdit.vue'),
			meta: {
				caslSubject: 'programs.program_forms',
				caslAction: 'edit',
			},
		},
		{
			path: ':id',
			name: ProgramsRouteName.editProposal,
			component: () => import('../../views/program/proposal/ProposalEdit.vue'),
			meta: {
				caslSubject: 'programs.program_forms',
				caslAction: 'view',
			},
		},
	];
}

export function programEvaluationsEditRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'new',
			name: ProgramsRouteName.newEvaluation,
			component: () =>
				import('../../views/program/evaluation/EvaluationEdit.vue'),
			meta: {
				caslSubject: 'programs.program_forms',
				caslAction: 'edit',
			},
		},
		{
			path: ':id',
			name: ProgramsRouteName.editEvaluation,
			component: () =>
				import('../../views/program/evaluation/EvaluationEdit.vue'),
			meta: {
				caslSubject: 'programs.program_forms',
				caslAction: 'view',
			},
		},
	];
}
